import { Component, inject, input, OnInit } from '@angular/core';
import { UserService } from '../../../services/user/user.service';
import { MatIcon } from '@angular/material/icon';
import { MatCardAvatar } from '@angular/material/card';
import { AsyncPipe, NgClass } from '@angular/common';
import { Observable } from 'rxjs';
import { PresenceStatus } from '../../../services/presence/presence.service';

@Component({
  selector: 'app-user-icon',
  imports: [MatIcon, MatCardAvatar, AsyncPipe, NgClass],
  templateUrl: './user-icon.component.html',
  styleUrl: './user-icon.component.scss'
})
/**
 * Komponente zur Anzeige von Usericons
 *
 * Begründung: Diese Komponente erfüllt keine AFO, da sie dem reinen Design dient
 *
 **/
export class UserIconComponent implements OnInit {
  userId = input<string>('');
  presenceStatus = input<Observable<PresenceStatus>>();
  scaleForPinned = input<boolean>(false);
  showStatus = input<boolean>(true);
  public readonly userService = inject(UserService);

  public ngOnInit(): void {
    this.userService
      .initialLoad(this.userId())
      .finally(() => this.userService.userIconInitialLoad.set(this.userId(), true));
  }
}
